// extracted by mini-css-extract-plugin
export default {"container":"container__ZGMyY","title":"title__YTg5M","description":"description__YTIwN","dismiss":"dismiss__NzdiM"};